
import { Component, Vue } from "vue-property-decorator";
import { AuditTableInterface, ComponentInterface } from "@/services/Dev-scrum/interfaces";
import DevScrumRepository from "@/services/Dev-scrum";
import { DataTableHeader } from "vuetify";
import DeleteDepartmentDialog from "@/components/dialogs/departments/DeleteDepartmentDialog.vue";
import DeleteComponentDialog from "@/components/dialogs/dev-scrums/DeleteComponentDialog.vue";
import { DepartmentInterface } from "@/services/Departments/Interfaces";

@Component({
  components: {
    DeleteComponentDialog,
  },
  inject: [
    'devScrumRepository',
  ],
})
export default class ViewComponent extends Vue {
  private loading: boolean = true;
  private components: ComponentInterface[] = [];
  private readonly devScrumRepository!: DevScrumRepository;
  private deleteComponentDialog: string = '';
  private deleteComponentForDialog: ComponentInterface | false = false;

  private headers: DataTableHeader[] = [
    { text: 'ID', value: 'id' },
    { text: 'Name', value: 'name', sortable: false },
    { text: 'Status', value: 'status' },
    { text: 'Actions', value: 'actions', sortable: false },

  ];

  private async created(): Promise<void> {
    await this.initialize();
  }

  private async initialize(): Promise<void>{
    this.components = await this.devScrumRepository.getAllComponents() as [];
    this.loading = false;

  }

  private createComponent(): void {
    this.$router.push({ name: 'create_component' });
  }

  private editComponent(component: ComponentInterface): void {
    if (component.id !== undefined) {
      this.$router.push({ name: 'component_edit', params: { componentId: component.id.toString() } });
    }
  }

  private async deleteComponent(component: ComponentInterface): Promise<void> {
      this.deleteComponentDialog = 'delete-component-dialog';
      this.deleteComponentForDialog = component;
  }
  private async onComponentDeleted(deletedComponentId: number): Promise<void> {
    this.components = this.components.filter(component => component.id !== deletedComponentId);
  }
}

